import { ISchoolUser } from '../api/ischool-user';

export interface ISchoolUserState {
  schoolUser: ISchoolUser,
  schoolUsers: ISchoolUser[],
  error?: any
}
